import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@/app/constants/queryKeys';
import { QueryTimers } from '@/infra/network/query';
import { projectsService } from '@/modules/projects/services';

const projectDetailsQueryOptions = (projectId: string) =>
  queryOptions({
    gcTime: QueryTimers.FIVE_MINUTES,
    staleTime: QueryTimers.FIVE_MINUTES,
    refetchInterval: QueryTimers.FIVE_MINUTES,
    queryKey: queryKeys.projects.detail(projectId),
    queryFn: () => projectsService.getProjectDetails({ projectId }),
  });

export { projectDetailsQueryOptions };
